import { KontaktdatenComponent } from '../../../netzbetreiber/kontaktdaten/kontaktdaten.component';
import { Component, OnInit, inject } from '@angular/core';
import { UflaUser } from '../../../service/auth/ufla-user';
import { AuthenticationService } from '../../../service/auth/authentication.service';
import { Router } from '@angular/router';
import { ConfirmDialogService } from '../../../service/common/confirm-dialog/confirm-dialog.service';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { MatDialog } from '@angular/material/dialog';
import { AnleitungService } from '../../../service/anleitung/anleitung.service';

@Component({
    selector: 'ufla-navigation-header',
    templateUrl: './navigation-header.component.html',
    styleUrls: [
        './navigation-header.component.scss',
    ],
    standalone: false,
})
export class NavigationHeaderComponent implements OnInit {
    dialog = inject(MatDialog);
    authenticationService = inject(AuthenticationService);
    router = inject(Router);
    private confirmDialogService = inject(ConfirmDialogService);
    anleitungService = inject(AnleitungService);


    public ASSET_URL = environment.ASSET_URL;
    public user$: Observable<UflaUser> = null;

    async ngOnInit() {
        this.user$ = this.authenticationService.user$;
        this.anleitungService.reloadAnleitungPresent();
    }

    public login() {
        this.authenticationService.login();
    }

    public async logout() {
        if (await this.confirmDialogService.showDialog(
            'Möchten Sie sich wirklich ausloggen?',
            'Ausloggen?',
            'primary',
            'Ja', 'Nein')) {
            await this.authenticationService.logout();
        }
    }

    public openKontaktdaten() {
        this.dialog.open(KontaktdatenComponent, {
            panelClass: 'ufla-detail-dialog-container',
            disableClose: true,
        });
    }
}
